import { HOUR_IN_MILLISECONDS } from 'config';
import {
  ProjectDto,
  useProjectQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { ApprovalPresetGroupsPageParams } from './constants';

export type ApprovalPresetGroupsQueries = [
  UseQueryResult<ProjectDto, unknown>,
];

const useApprovalPresetGroupsQueries = (params: ApprovalPresetGroupsPageParams): ApprovalPresetGroupsQueries => {
  const projectQuery = useProjectQuery(params.projectId, {
    staleTime: HOUR_IN_MILLISECONDS,
  });

  return [projectQuery];
};

export default useApprovalPresetGroupsQueries;
